import * as z from "zod";

export const customerInquirySchema = z.object({
    requestorName: z
    .string()
    .trim()
    .min(1, "작성자를 입력해주세요."),
    email: z
    .string()
    .email("유효한 이메일 주소를 입력해주세요."),
    title: z
    .string()
    .trim()
    .min(1, "문의 제목을 입력해주세요."),
    contents: z
    .string()
    .trim()
    .min(10, "문의 내용은 10자 이상 입력해주세요.")
    .max(1000, "문의 내용은 1000자 이하로 입력해주세요.")
});

// 🔹 타입 정의
export type CustomerInquiryFormValues = z.infer<typeof customerInquirySchema>;